export const UPDATE_DATEPICKER = "UPDATE_DATEPICKER";
export const GET_TRACKERS = "GET_TRACKERS";
export const SAVE_TRACKERS = "SAVE_TRACKERS";
export const SELECT_TRACKER = "SELECT_TRACKER";
export const SELECT_INITIAL_TRACKER = "SELECT_INITIAL_TRACKER";
export const GET_TRACKER_FROM_PARAM = "GET_TRACKER_FROM_PARAM";
export const CLEAR_SELECTED_TRACKER = "CLEAR_SELECTED_TRACKER";
export const CLEAR_AVAILABLE_TRACKERS = "CLEAR_AVAILABLE_TRACKERS";
export const GET_TRACKER_DATE = "GET_TRACKER_DATE";
